/**
 * Centralized depth constants for @cinemark/content-api-client calls.
 * Depth controls how many levels of nested relations are returned from the Content API.
 */
export const ContentApiDepths = {
  articles: 1,
  attributes: 2,
  avatars: 1,
  bannerCampaigns: 2,
  bulletins: 2,
  concessions: 2,
  contentFolders: 2,
  contentPages: 3,
  familyEntertainmentCenter: 2,
  featuredMovie: 1,
  featuredMovies: 0,
  genre: 2,
  imageAssets: 1,
  ingredientModifiers: 1,
  legalDocuments: 0,
  legalPolicies: 0,
  movieCatalog: 1,
  movieDetails: 3,
  movies: 1,
  privateWatchParty: 1,
  products: 1,
  promoContents: 1,
  screenings: 1,
  theaterLookup: 1,
  theaters: 2,
  ticketSeatMap: 2,
} as const;
